let youtubeVideos = [];
class VideoPlayPause {
  constructor() {
    this.init()
  }
 
  // Video play pause
 
  actionOnYoutube = (e,btn,button,type) => {
    e.preventDefault();
 
    // normal video
    let parent = e.target.closest(".video-wrapper-js");
    btn.classList.add('hide');
    parent.querySelector(button).classList.remove('hide');
    let videos = parent?.querySelectorAll("video");
    videos.forEach(video => {
      if (type == 'play') {
        video.play();
      }
      else if(type == 'pause') {
        video.pause();
      }
      else if(type == 'mute') {
        video.muted = true;
      }else {
        video.muted = false;
      }
    })
 
    // youtube
    let blockId = parent.getAttribute('block-id');
    youtubeVideos.length > 0 && youtubeVideos.forEach(el=> {
      if (el.id == blockId) {
        if (type == 'play') {
          el.player.playVideo();
        }
        else if(type == 'pause') {
          el.player.pauseVideo();
        }
        else if(type == 'mute') {
          el.player.mute();
        }else {
          el.player.unMute();
        }
      }
    })
 
    // vimeo
    let vimeoVideo = qs('[data-type="vimeo"]',parent);
    if (vimeoVideo) {
      let player = new Vimeo.Player(vimeoVideo.id, { id: vimeoVideo.dataset.videoId })
      if (type == 'play') {
        player.play();
      }
      else if(type == 'pause') {
        player.pause();
      }
      else if(type == 'mute') {
        player.setVolume(0);
      }else {
        player.setVolume(1);
      }
    }
  }
 
  videoPause = () => {
    let pause = document.querySelectorAll(".video-wrapper-js .video-buttons .pause");
    pause.forEach(btn => {
      btn.addEventListener("click", (e) => {
        this.actionOnYoutube(e,btn,'.play','pause');
      })
    })
  }
  videoPlay = () => {
    let play = document.querySelectorAll(".video-wrapper-js .video-buttons .play");
    play.forEach(btn => {
      btn.addEventListener("click", (e) => {
        this.actionOnYoutube(e,btn,'.pause','play');
      })
    })
  }
 
       
 
  // Video mute unmute
 videoMute = () => {
  let mute = document.querySelectorAll(".video-wrapper-js .video-buttons .mute");
  mute.forEach(btn => {
    btn.addEventListener("click", (e) => {
      this.actionOnYoutube(e, btn, '.unmute', 'mute');
    })
  })
}
 
videoUnmute = () => {
  let unmute = document.querySelectorAll(".video-wrapper-js .video-buttons .unmute");
  unmute.forEach(btn => {
    btn.addEventListener("click", (e) => {
      this.actionOnYoutube(e, btn, '.mute', 'unmute');
    })
  })
}
 
  init = () => {
    this.videoPlay();
    this.videoPause();
    this.videoUnmute();
    this.videoMute();
  }
}
 
if (document.querySelector('.video-wrapper-js')) new VideoPlayPause()
 
if (qs('.video-wrapper-js') && qs('.video-wrapper-js iframe[data-type="youtube"]')) {
  let iframes = qsa('.video-wrapper-js iframe[data-type="youtube"]');
  if (iframes.length > 0) {
    function onYouTubePlayerAPIReady() {
      iframes.forEach(el=> {
        let player = new YT.Player(el.id);
        let id = el.closest('.video-wrapper-js').getAttribute('block-id');
        youtubeVideos.push({id,player});
      })
    }
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}
 